import { logError } from '../logger';

export const validateSurvey = (data) => {
  const errors = [];

  try {
    // Required fields
    if (!data.name?.trim()) {
      errors.push('Survey name is required');
    }

    if (!data.customerName?.trim()) {
      errors.push('Customer name is required');
    }

    // Only validate vehicle type
    if (!data.vehicle?.type?.trim()) {
      errors.push('Please select a vehicle type');
    }

    // Survey type validation
    if (!data.surveyType?.trim()) {
      errors.push('Please select a survey type');
    }

    return errors;
  } catch (error) {
    logError('Survey validation error:', error);
    return ['An unexpected error occurred during validation'];
  }
};